export enum DashboardTab {
  DASHBOARDS = 'dashboards',
  TEMPLATES = 'templates',
}

interface State {
  selectedTab: DashboardTab;
  setSelectedTab: (tab: DashboardTab) => void;
}

export type { State };
